<template>
  <div style="position: relative;">
    <!-- <V3CashOut v-if="showCashOut" :cashOutMoneyList="cashOutMoneyList" :typeId="typeId" @closecashout="closecashout"></V3CashOut> -->
    <div id="v3BagDiv">
      <div id="v3ArrowDiv" @click="onBackClick()"><img id="v3Arrow" src="~assets/img/SdkV3/ArrowLeft.png" /></div>
      <div id="v3TitleDiv">
        礼 包
      </div>
      <div style="display:flex;flex-direction:column;align-items: center;background-color: #F6F6F6;width: 85vw;padding-top: 5px;">
        <div v-for="(item, index) in $store.state.bagList" :key="index" :index="index + ''">
          <!-- {\"typeid\":1,\"money\":0.99,\"name\":\"登录红包\"} -->
          <!-- <div style="display:flex;flex-direction:row;align-items:center;width:78vw;height:50px;border-radius: 8px;padding-left: 5px;padding-top: 5px;padding-bottom: 5px;margin-top: 5px;position: relative;"
          :style="{'background': item.status == '1'?'-webkit-linear-gradient(left, #FFEFE0,#FFFFFF)':'white'}"> -->
          <div style="display:flex;flex-direction:row;align-items:center;width:78vw;min-height: 50px;border-radius: 8px;padding-left: 5px;padding-top: 5px;padding-bottom: 5px;margin-top: 5px;position: relative;"
          :style="{'background': 'white'}">
            <div style="height:42px;width:60vw;display:flex;flex-direction:column;justify-content:center;padding-left: 10px;">
              <span style="font-size:x-small;font-weight: bold;">{{ item['name'] }}</span>
              <span style="font-size:xx-small;color: #989898;">{{ item['content'] }}</span>
            </div>
            <button @click="getBag(item)">查 看</button>
            <!-- <button v-if="item.status == '1'" @click="getBag(item)">领 取</button>
            <button v-else @click="checkBag(item)">查 看</button> -->
          </div>
        </div>
      </div>
    </div>
    <ShowBagWord v-show="showBagWordDialog" :bagWord="bagWord" @hideBagWordPage="hideBagWordPage"></ShowBagWord>
  </div>
</template>

<script>
import { request } from '@/network/request';
import getRequestParams from "@/signParams";
import ShowBagWord from './ShowBagWord.vue'
export default {
  props:{
    
  },
  data() {
    return {
      showCashOut: false,
      cashOutMoneyList: [],
      typeId: "",
      showBagWordDialog: false,
      bagWord: "",
    }
  },
  components: {
    ShowBagWord
  },
  methods:{
    closecashout(){
      this.showCashOut = false
    },
    hideBagWordPage(){
      this.showBagWordDialog = false
    },
    onBackClick(){
      this.$emit('hidebagpage')
    },
    checkBag(item){
      //查看礼包
      console.log(item); 
      
    },
    getBag(item){
      // 领取礼包
      console.log(item);
      this.showBagWordDialog = true
      this.bagWord = item.code
      
    },
  }
}
</script>

<style>
#v3BagDiv {
  position: relative;
  display: flex;
  flex-direction: column;
}

#v3TitleDiv {
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #B4B4B4;
}

#v3ArrowDiv {
  position: absolute;
  float: left;
  height: 40px;
  display: flex;
  align-items: center;
}

#v3Arrow {
  height: 25px;
  width: 25px;
  object-fit: scale-down;
}


#v3BagDiv button{
  background: -webkit-linear-gradient(left, #FA7D23,#FA7D23);
  border-radius: 20px;
  padding-top: 3px;
  padding-bottom: 3px;
  /* height: 30px; */
  /* width: 94%; */
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 3px;
  padding-bottom: 3px;
  color: white;
  font-size: xx-small;
  border: none;
  position: absolute;
  right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/bag/V3Bag.vue